// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PreDistributionTelekino_container__cyptK {
  animation: PreDistributionTelekino_init__J68CT 1s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

/*--Header--*/
.PreDistributionTelekino_container__cyptK .PreDistributionTelekino_header__AOAei {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.PreDistributionTelekino_container__cyptK .PreDistributionTelekino_header__AOAei .PreDistributionTelekino_titleContainer__eXhgO {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.PreDistributionTelekino_container__cyptK .PreDistributionTelekino_header__AOAei .PreDistributionTelekino_titleContainer__eXhgO h4 {
  text-align: center;
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

.PreDistributionTelekino_container__cyptK .PreDistributionTelekino_header__AOAei .PreDistributionTelekino_uploadBtn__k75CX {
  margin-bottom: 10px;
  width: 100%;
}

.PreDistributionTelekino_container__cyptK .PreDistributionTelekino_noResults__U5MI2 {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 300;
  height: 300px;
}

.PreDistributionTelekino_container__cyptK .PreDistributionTelekino_header__AOAei .PreDistributionTelekino_filters__5jL5R {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.PreDistributionTelekino_container__cyptK .PreDistributionTelekino_header__AOAei .PreDistributionTelekino_filters__5jL5R .PreDistributionTelekino_filterButton__2VnAl {
  text-transform: capitalize;
  height: 3rem;
  width: 10rem;
  margin-bottom: 10px;
  border-radius: 5px;
}

.PreDistributionTelekino_container__cyptK .PreDistributionTelekino_header__AOAei .PreDistributionTelekino_filters__5jL5R .PreDistributionTelekino_filterButton__2VnAl p {
  font-size: 0.9rem;
  margin-left: 5px;
  font-weight: 400;
}

/*---Información---*/
.PreDistributionTelekino_container__cyptK .PreDistributionTelekino_data__A5vMY .PreDistributionTelekino_tableContainer__HmPQ4 {
  border-radius: 5px;
  max-height: 80vh;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.PreDistributionTelekino_container__cyptK .PreDistributionTelekino_data__A5vMY .PreDistributionTelekino_tableContainer__HmPQ4 .PreDistributionTelekino_iconbtn__sO-nV {
  transition: 0.3s;
  font-size: 1.8rem;
}

.PreDistributionTelekino_container__cyptK .PreDistributionTelekino_data__A5vMY .PreDistributionTelekino_tableContainer__HmPQ4 .PreDistributionTelekino_iconbtn__sO-nV:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(0.7);
  scale: 1.1;
}

.PreDistributionTelekino_container__cyptK .PreDistributionTelekino_data__A5vMY .PreDistributionTelekino_pagination__4lRbj {
  margin-top: 50px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.PreDistributionTelekino_container__cyptK .PreDistributionTelekino_loader__BCcrw {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.PreDistributionTelekino_labelUpload__Xr6yL {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  gap: 10px;
  transition: ease 0.5s;
}

.PreDistributionTelekino_input1__4kcvc {
  display: none;
}

.PreDistributionTelekino_container__cyptK .PreDistributionTelekino_loader__BCcrw {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.PreDistributionTelekino_select-container__K6irb {
  display: flex;
}

@keyframes PreDistributionTelekino_init__J68CT {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@media screen and (max-width: 500px) {
  .PreDistributionTelekino_container__cyptK .PreDistributionTelekino_header__AOAei .PreDistributionTelekino_titleContainer__eXhgO h4 {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/ProcessFiles/PreDistributionTelekino/PreDistributionTelekino.module.css"],"names":[],"mappings":"AAAA;EACE,iDAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n/*--Header--*/\n.container .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  text-align: center;\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n.container .header .uploadBtn {\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n.container .noResults {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 1.5rem;\n  font-weight: 300;\n  height: 300px;\n}\n\n.container .header .filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.container .header .filters .filterButton {\n  text-transform: capitalize;\n  height: 3rem;\n  width: 10rem;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.container .header .filters .filterButton p {\n  font-size: 0.9rem;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n/*---Información---*/\n.container .data .tableContainer {\n  border-radius: 5px;\n  max-height: 80vh;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .data .tableContainer .iconbtn {\n  transition: 0.3s;\n  font-size: 1.8rem;\n}\n\n.container .data .tableContainer .iconbtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(0.7);\n  scale: 1.1;\n}\n\n.container .data .pagination {\n  margin-top: 50px;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}\n\n.container .loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n.labelUpload {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  gap: 10px;\n  transition: ease 0.5s;\n}\n\n.input1 {\n  display: none;\n}\n\n.container .loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n.select-container {\n  display: flex;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .container .header .titleContainer h4 {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PreDistributionTelekino_container__cyptK`,
	"init": `PreDistributionTelekino_init__J68CT`,
	"header": `PreDistributionTelekino_header__AOAei`,
	"titleContainer": `PreDistributionTelekino_titleContainer__eXhgO`,
	"uploadBtn": `PreDistributionTelekino_uploadBtn__k75CX`,
	"noResults": `PreDistributionTelekino_noResults__U5MI2`,
	"filters": `PreDistributionTelekino_filters__5jL5R`,
	"filterButton": `PreDistributionTelekino_filterButton__2VnAl`,
	"data": `PreDistributionTelekino_data__A5vMY`,
	"tableContainer": `PreDistributionTelekino_tableContainer__HmPQ4`,
	"iconbtn": `PreDistributionTelekino_iconbtn__sO-nV`,
	"pagination": `PreDistributionTelekino_pagination__4lRbj`,
	"loader": `PreDistributionTelekino_loader__BCcrw`,
	"labelUpload": `PreDistributionTelekino_labelUpload__Xr6yL`,
	"input1": `PreDistributionTelekino_input1__4kcvc`,
	"select-container": `PreDistributionTelekino_select-container__K6irb`
};
export default ___CSS_LOADER_EXPORT___;
